import React, { useState, useRef, useEffect } from 'react';
import { DateRangePicker, createStaticRanges } from 'react-date-range';
import { addDays, startOfDay, endOfDay, subDays, isSameDay } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { FaCalendar } from 'react-icons/fa';

const customStaticRanges = createStaticRanges([
  {
    label: 'All Time',
    range: () => ({
      keyName: "allTime",
      startDate: new Date('2010-01-01'),
      endDate: new Date(),
    }),
  },
  {
    label: 'Today',
    range: () => ({
      keyName: "today",
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    }),
  },
  {
    label: 'Yesterday',
    range: () => ({
      keyName:"yesterday",
      startDate: startOfDay(subDays(new Date(), 1)),
      endDate: endOfDay(subDays(new Date(), 1)),
    }),
  }
]);

export default function DateRangeInput({ onSelect }) {
   const [open, setOpen] = useState(false);
   const [pendingStart, setPendingStart] = useState(null);
   const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });
    const ref = useRef(null);

    const handleSelect = (ranges) => {
        const selected = ranges.selection;
        //first click
        if (!pendingStart || (pendingStart && selected.endDate.getTime() === pendingStart.getTime()) || (selected.endDate === selected.startDate)) {

            setPendingStart(selected.startDate);

            setRange({
            startDate: selected.startDate,
            endDate: selected.endDate,
            key: "selection",
            keyName: "custom",
            isIncomplete: true,
            });

            return;
        }

        // second click 
        const matchedStatic = customStaticRanges.find((r) => {
            const rangeDates = r.range();
            return (
            isSameDay(selected.startDate, rangeDates.startDate) &&
            isSameDay(selected.endDate, rangeDates.endDate)
            );
        });

        const finalRange = {
            startDate: pendingStart,
            endDate: selected.endDate,
            key: "selection",
            keyName: matchedStatic ? matchedStatic.range().keyName : "custom",
        };

        setPendingStart(null);
        setRange(finalRange);
    };


    const handleApply = () => {
        if (onSelect) onSelect(range);
        setOpen(false);
    }

  // Format display text for input
    const formatted =
        range.startDate.toLocaleDateString() +
        ' - ' +
        range.endDate.toLocaleDateString();

    // Close dropdown if clicked outside
        useEffect(() => {
        const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
        }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 768);
  handleResize(); // initial check
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  return (
    <div ref={ref} className="relative inline-block  md:w-auto w-full">
      {/* Input */}
      <input
        type="text"
        readOnly
        value={formatted}
        onClick={() => setOpen(!open)}
        className=" border border-gray-300 rounded-md py-3 pl-2 pr-8 cursor-pointer outline-none md:w-auto w-full "
      />
      <FaCalendar
        onClick={() => setOpen(!open)}
        className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
        size={18}
      />

      {/* Date picker popup */}
      {open && (
        <div className="absolute z-50 mt-2 w-full md:w-auto rounded-lg bg-white shadow-lg left-0 overflow-scroll">
          <DateRangePicker
            displayMode="dateRange"
            dragSelectionEnabled
            onChange={handleSelect}
            ranges={[range]}
            staticRanges={customStaticRanges}
            inputRanges={[]}
            showSelectionPreview
            moveRangeOnFirstSelection={false}
            direction={isMobile ? 'vertical' : 'horizontal'}
            months={isMobile ? 1 : 2}
            
            className=" w-full md:w-full p-2  overflow-scroll "
          />
          <div className=" flex flex-row justify-end border-t border-gray-200 p-2">
            <button
              onClick={() => setOpen(false)}
              className="btn btn-light btn-sm mr-2 px-3 py-1 text-dbase1 rounded bg-gray-100 hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              onClick={handleApply}
              className="btn btn-primary btn-sm px-3 py-1 rounded bg-blue-600 text-dblue hover:bg-blue-700"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
